import React from "react";
import { ThemeProvider } from "styled-components";
import Theme from "./Theme";
import { BrowserRouter } from "react-router-dom";
import { Switch, Route } from "react-router";
import ReactGA from "react-ga";
import Home from "./pages/Home";
import DataProtection from "./pages/DataProtection";
import Imprint from "./pages/Imprint";

function App() {
  ReactGA.initialize("UA-159389093-2");

  return (
    <ThemeProvider theme={Theme as typeof Theme}>
      <BrowserRouter>
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route path="/impressum">
            <Imprint />
          </Route>
          <Route path="/datenschutz">
            <DataProtection />
          </Route>
        </Switch>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
